<template>
    <div class="white_bg">
        <el-config-provider :locale="zhCn">
            <el-tabs v-model="activeName" @tab-click="handleClick">

                <el-tab-pane label="自选时间" name="index">
                    <div class="p-title">
                        <div class="p-block"></div>筛选时间
                    </div>

                    <div class="date-bg">
                        <div class="date-text">开始时间</div>
                        <el-date-picker v-model="tempStartMonth" type="month" placeholder="年/月" :prefix-icon="null"
                            :clear-icon="null" format="YYYY-MM" value-format="YYYY-MM" :disabled-date="disabledStartDate">
                        </el-date-picker>
                        <div class="date-line"></div>
                        <div class="date-text">结束时间</div>
                        <el-date-picker v-model="tempEndMonth" type="month" placeholder="年/月" :prefix-icon="null"
                            :clear-icon="null" format="YYYY-MM" value-format="YYYY-MM" :disabled-date="disabledEndDate">
                        </el-date-picker>
                        <div @click="search" class="date-btn">筛选</div>
                    </div>

                    <div class="p-title">
                        <div class="p-block"></div>功能点数升级统计结果
                    </div>

                    <div class="index-count">
                        <div class="count-box" :class="{ 'count-checked': functionStage > 0 }">
                            <div class="count-title">
                                <div class="count-line"></div>
                                <div class="count-text">按功能模块统计</div>
                                <div class="count-line"></div>
                            </div>
                            <div class="count-title-2">升级占比</div>
                            <div class="charts">
                                <v-chart class="chart" :option="functionOption" style="width:300px;height: 300px;"
                                    @click="onFunctionChartClick" />

                            </div>

                        </div>


                        <div class="count-box" style="width:730px;" :class="{ 'count-checked': brandStage > 0 }">
                            <div class="count-title">
                                <div class="count-line"></div>
                                <div class="count-text">按车型统计</div>
                                <div class="count-line"></div>
                            </div>
                            <div class="count-title-2">TOP 10</div>

                            <div class="charts">
                                <v-chart class="chart" :option="brandOption" style="width:730px;height: 300px;"
                                    @click="onBrandChartClick" />
                            </div>
                        </div>

                    </div>


                    <div class="index-count">
                        <div class="count-box">
                            <div class="count-title">
                                <div class="count-line"></div>
                                <div class="count-text">按升级类型统计</div>
                                <div class="count-line"></div>
                            </div>
                            <div class="count-title-2">类型占比</div>

                            <div class="charts">
                                <v-chart class="chart" :option="addTypeOption" style="width:300px;height: 300px;" />

                            </div>
                        </div>


                        <div class="count-box" style="width:730px;" :class="{ 'count-checked': brandStage > 0 }">
                            <div class="count-title">
                                <div class="count-line"></div>
                                <div class="count-text">按升级次数统计</div>
                                <div class="count-line"></div>
                            </div>
                            <div class="count-title-2">TOP 10</div>

                            <div class="charts" style="padding-left: 30px;">
                                <v-chart class="chart" :option="versionOption" style="width:730px;height: 300px;"
                                    @click="onBrandChartClick" />
                            </div>
                        </div>
                    </div>


                    <div class="child-1">
                        <div v-if="functionStage >= 1">
                            <div class="c-title">{{ currentFunction0.name }}功能点数占比</div>
                            <div class="c-title-line">
                                <div class="line-1"></div>
                                <div class="line-2"></div>
                            </div>

                            <v-chart class="chart" :option="function1Option" style="width:500px;height: 300px;"
                                @click="onFunction1ChartClick" />
                        </div>
                        <div class="mt-10" v-if="functionStage >= 2">
                            <div class="c-title">{{ currentFunction1.name }}升级点数</div>
                            <div class="c-title-line">
                                <div class="line-1"></div>
                                <div class="line-2"></div>
                            </div>

                            <v-chart class="chart" :option="function2Option" style="width:1000px;height: 300px;"
                                @click="onFunction2ChartClick" />
                        </div>

                        <div class="mt-10" v-if="brandStage >= 1">
                            <div class="c-title">{{ currentBrand.name }} 升级统计</div>
                            <div class="c-title-line">
                                <div class="line-1"></div>
                                <div class="line-2"></div>
                            </div>

                            <v-chart class="chart" :option="brandFuncOption" style="width:1500px;height: 400px;"
                                @click="onBrandFuncChartClick" />
                        </div>

                        <div class="mt-10 ota-detail-list" v-if="functionStage >= 3 || brandStage >= 2">
                            <div class="c-title">{{ currentFunction2.name }}</div>
                            <div class="c-title-line">
                                <div class="line-1"></div>
                                <div class="line-2"></div>
                            </div>

                            <div class="mt-10 detail-list">
                                <div class="detail-item" v-for="(item, index) in functionDetail" :key="item.id">
                                    <div class="detail-item-title">{{ index + 1 }}.{{ item.intro }}


                                        <div class="like-btn" @click="searchLike(item, 1)">ota内容对比信息搜索</div>
                                        <div v-if="item.item != '创新项' && item.item != '智驾'" class="like-btn"
                                            @click="searchLike(item, 2)">车型评测对比信息搜索</div>
                                        <div v-if="item.item == '创新项'" class="like-btn" @click="searchLike(item, 3)">
                                            车型评测对比信息搜索</div>
                                    </div>

                                    <div class="detail-content">
                                        {{ item.content }}
                                    </div>
                                    <div class="detail-item-main">
                                        <el-image v-for="img in item.attachment" class="detail-img" :src="img.link_url"
                                            :key="img.id" :preview-src-list="[img.link_url]" fit="cover" />
                                    </div>
                                    <div class="detail-item-model">
                                        <div>{{ item.brand.name }}&nbsp;&nbsp;|&nbsp;&nbsp; {{ item.model
                                            }}</div>
                                        <div class="detail-item-model-date">{{ item.published }}</div>
                                    </div>
                                    <div class="sp-line"></div>

                                </div>



                            </div>
                        </div>
                    </div>

                </el-tab-pane>

                <el-tab-pane :lazy="true" label="年度统计" name="year">
                    <div class="c-title mt-10">OTA升级功能点年度统计</div>
                    <div class="c-title-line">
                        <div class="line-1"></div>
                        <div class="line-2"></div>
                    </div>
                    <v-chart class="chart" :option="yearFunctionOption" style="width:900px;height: 300px;" />

                    <div class="c-title mt-50">OTA升级功能点年度统计</div>
                    <div class="c-title-line">
                        <div class="line-1"></div>
                        <div class="line-2"></div>
                    </div>
                    <v-chart class="chart" :option="yearBrandOption" style="width:900px;height: 600px;" />

                    <div class="c-title mt-50">车企OTA推送月数TOP10</div>
                    <div class="c-title-line">
                        <div class="line-1"></div>
                        <div class="line-2"></div>
                    </div>
                    <v-chart class="chart" :option="other1Option" style="width:1250px;height: 250px;" />
                    <div class="c-title mt-50">车企OTA推送总次数TOP10</div>
                    <div class="c-title-line">
                        <div class="line-1"></div>
                        <div class="line-2"></div>
                    </div>
                    <v-chart class="chart" :option="other2Option" style="width:1250px;height: 250px;" />
                    <div class="c-title mt-50">单车型OTA推送次数TOP10</div>
                    <div class="c-title-line">
                        <div class="line-1"></div>
                        <div class="line-2"></div>
                    </div>
                    <v-chart class="chart" :option="other3Option" style="width:1250px;height: 250px;" />


                </el-tab-pane>
            </el-tabs>
        </el-config-provider>
    </div>
    <!-- 自定义对话框 -->
    <div v-if="dialogVisible" class="custom-dialog-mask" @click="closeDialog">
        <div class="custom-dialog" @click.stop>
            <div v-if="searchType == 1">
                <div class="custom-dialog-header">
                    <span>ota内容对比信息搜索</span>
                    <button class="close-button" @click="closeDialog">×</button>
                </div>
                <div class="custom-dialog-content">
                    <!-- 对话框内容 -->
                    <div class="mt-10 detail-list">
                        <div class="detail-item" v-for="(item, index) in keywordDetail" :key="item.id">
                            <div class="detail-item-title">{{ index + 1 }}.{{ item.intro }}</div>
                            <div class="detail-content">{{ item.content }}</div>
                            <div class="detail-item-main">
                                <el-image v-for="img in item.attachment" class="detail-img" :src="img.link_url"
                                    :key="img.id" :preview-src-list="[img.link_url]" fit="cover" />
                            </div>
                            <div class="detail-item-model">
                                <div>{{ item.brand.name }}&nbsp;&nbsp;|&nbsp;&nbsp; {{ item.model }}</div>
                                <div class="detail-item-model-date">{{ item.published }}</div>
                            </div>
                            <div class="sp-line"></div>
                        </div>
                    </div>
                </div>

            </div>




            <div v-if="searchType == 2">
                <div class="custom-dialog-header">
                    <span>车型评测对比信息搜索</span>
                    <button class="close-button" @click="closeDialog">×</button>
                </div>
                <div class="custom-dialog-content">
                    <el-table v-if="node_list" empty-text="没有匹配的相关项目节点" v-loading="loading" :data="node_list"
                        row-key="id" border>
                        <el-table-column :resizable="false" label="测评项" width=420>
                            <template #default="scope">
                                <div class="node_name">
                                    {{ scope.row.name }}
                                </div>
                                <div class="path_names">( <template v-for="(item, ind) in scope.row.path_node"
                                        :key="ind">
                                        <span v-if="ind > 0">></span><span>{{ item.node_name }}</span>
                                    </template> )
                                </div>
                                <div></div>
                            </template>
                        </el-table-column>
                        <el-table-column :resizable="false" label="得分" min-width=300>
                            <template #default="scope">
                                <el-checkbox-group v-model="scope.row.checked_list" :max="3">
                                    <div class="model_list flex">
                                        <el-checkbox class="model_name" v-for="item in scope.row.model_list"
                                            :key="item.model_id" :label="item">
                                            {{ item.short_name }}({{ item.score }}分)
                                        </el-checkbox>
                                    </div>
                                </el-checkbox-group>
                            </template>
                        </el-table-column>
                        <el-table-column :resizable="false" label="操作" width=80>
                            <template #default="scope">
                                <div class="contrast_btn" @click="contrastFn(scope.row); showRuleDesc = false;">对比</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>

            <div v-if="searchType == 3">
                <div class="custom-dialog-header">
                    <span>车型评测对比信息搜索</span>
                    <button class="close-button" @click="closeDialog">×</button>
                </div>
                <div class="custom-dialog-content">
                    <el-table v-if="node_list2" empty-text="没有匹配的相关项目节点" v-loading="loading" :data="node_list2"
                        row-key="id" border :span-method="objectSpanMethod">
                        <el-table-column :resizable="false" label="测评项" width=420>
                            <template #default="scope">
                                <div class="node_name">
                                    {{ scope.row.name }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :resizable="false" label="得分" min-width=300>
                            <template #default="scope">
                                <el-checkbox-group v-model="scope.row.checked_list" :max="3">
                                    <div class="model_list flex">
                                        <el-checkbox class="model_name" v-for="item in scope.row.model_list"
                                            :key="item.model_id" :label="item">
                                            {{ item.short_name }}({{ item.score }}分)
                                        </el-checkbox>
                                    </div>
                                </el-checkbox-group>
                            </template>
                        </el-table-column>
                        <el-table-column :resizable="false" label="操作" width=80>
                            <template #default="scope">
                                <div class="contrast_btn" @click="contrastFn2(scope.row); showRuleDesc = false;">对比
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>

    <el-drawer v-model="dialogCompareVisible" :title="node_name" direction="rtl" :before-close="handleClose"
        :size="'auto'" modal-class="modal_transparent">
        <div class="my_dialog" v-if="dialogCompareVisible">
            <table class="detail_table" border="1">
                <tr class="detail_title">
                    <td class="detail_attr">车型</td>
                    <template v-for="(item, ind) in model_list" :key="ind">
                        <td class="detail_title_item" colspan="1">
                            {{ item.short_name }}
                        </td>
                    </template>
                </tr>
                <tr class="detail_tr_item" v-show="showRuleDesc == true">
                    <td class="detail_attr">
                        标准
                        <span id="triangle-up" @click="showRuleDesc = false"></span>
                    </td>
                    <template v-for="(item, ind) in detail_list" :key="ind">
                        <td class="detail_val">
                            <template v-if="item.has_permission == 1">未开通权限</template>
                            <template v-else>
                                <div class="detail_val_text" v-html="(item['9'] && item['9']) || '暂无'"></div>
                            </template>

                        </td>
                    </template>
                </tr>
                <tr class="detail_tr_item">
                    <!-- 背景色占位 -->
                </tr>
                <tr class="detail_tr_item" v-show="showRuleDesc == false">
                    <td class="detail_attr">
                        标准
                        <span id="triangle-down" @click="showRuleDesc = true"></span>
                    </td>
                    <template v-for="(item, ind) in detail_list" :key="ind">
                        <td class="detail_val">
                            <template v-if="item.has_permission == 1">未开通权限</template>
                            <template v-else>
                                <div style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 5px;
                  " class="detail_val_text" v-html="(item['9'] && item['9']) || '暂无'"></div>
                            </template>
                        </td>
                    </template>
                </tr>
                <tr class="detail_tr_item">
                    <td class="detail_attr">
                        <div>得分</div>
                    </td>
                    <template v-for="(item, ind) in detail_list" :key="ind">
                        <td class="detail_val">
                            <template v-if="item.has_permission == 1">未开通权限</template>
                            <template v-else>
                                <div class="attr_box">
                                    <!-- <div class="attr_node_name">
                    {{ node_name }}
                  </div> -->
                                    <div class="attr_node_score">
                                        <span class="attr_node_score_num" style="color:#f00">{{ (item["1"] &&
                                            item["1"].item_value_val) ||
                                            0 }}分</span>
                                    </div>
                                </div>
                            </template>
                        </td>
                    </template>
                </tr>
                <tr class="detail_tr_item">
                    <td class="detail_attr">主观评价</td>
                    <template v-for="(item, ind) in detail_list" :key="ind">
                        <td class="detail_val">
                            <template v-if="item.has_permission == 1">未开通权限</template>
                            <template v-else>
                                <div class="detail_val_text" v-html="(item['2'] && item['2'].item_value_val) || '暂无'">
                                </div>
                            </template>
                        </td>
                    </template>
                </tr>
                <!-- <tr class="detail_tr_item">
            <td class="detail_attr">客观信息</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div
                  class="detail_val_text"
                  v-html="(item['3'] && item['3'].item_value_val) || '暂无'"
                ></div>
              </td>
            </template>
          </tr> -->
                <tr class="detail_tr_item">
                    <td class="detail_attr">图片素材</td>
                    <template v-for="(item, ind) in detail_list" :key="ind">
                        <td class="detail_val">
                            <template v-if="item.has_permission == 1">未开通权限</template>
                            <template v-else>
                                <template v-if="item['4'] && item['4'].ext_info.length > 0">
                                    <div class="detail_val_pic">
                                        <div class="detail_pic_left" @click.stop="
                                            previewImg(item['4'] && item['4'].ext_info, 'img')
                                            ">
                                            <div class="detail_pic_left_img">
                                                <img :src="item['4'].ext_info[0].attach_value || ''" alt="图片加载失败" />
                                                <span class="more_pic">{{
                                                    item["4"] && item["4"].ext_info.length
                                                }}</span>
                                            </div>
                                            <div class="look_pic">点击查看图片</div>
                                        </div>
                                        <div v-if="item['4'] && item['4'].item_value_val"
                                            class="detail_pic_right detail_val_text"
                                            v-html="item['4'] && item['4'].item_value_val"></div>
                                    </div>
                                    <!-- <div class="download_btn"
                                        @click="downloadFn(item['4'] && item['4'].ext_info, model_list[ind].short_name, node_name)">
                                    </div> -->
                                </template>
                                <div class="no_img" v-else>当前测试子节点本次未涉及图片素材</div>
                            </template>
                        </td>
                    </template>
                </tr>
                <tr class="detail_tr_item">
                    <td class="detail_attr">视频素材</td>
                    <template v-for="(item, ind) in detail_list" :key="ind">
                        <td class="detail_val">
                            <template v-if="item.has_permission == 1">未开通权限</template>
                            <template v-else>
                                <template v-if="item['5'] && item['5'].ext_info.length > 0">
                                    <div class="detail_val_video">
                                        <div class="detail_video_left" @click.stop="
                                            previewImg(item['5'] && item['5'].ext_info, 'video')
                                            ">
                                            <div class="detail_pic_left_video">
                                                <video controlsList="nodownload"
                                                    :src="item['5'].ext_info[0].attach_value"
                                                    :poster="item['5'].ext_info[0].attach_value + '?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'"
                                                    preload="none"></video>
                                                <span class="more_pic">{{
                                                    item["5"] && item["5"].ext_info.length
                                                }}</span>
                                            </div>
                                            <div class="look_pic">点击查看视频</div>
                                        </div>
                                        <div class="detail_pic_right detail_val_text"
                                            v-if="item['5'] && item['5'].item_value_val"
                                            v-html="item['5'] && item['5'].item_value_val"></div>
                                    </div>
                                    <!-- <div class="download_btn"
                                        @click="downloadFn(item['5'] && item['5'].ext_info, model_list[ind].short_name, node_name)">
                                    </div> -->
                                </template>
                                <div class="no_img" v-else>当前测试子节点本次未涉及视频素材</div>
                            </template>
                        </td>
                    </template>
                </tr>
            </table>
        </div>
    </el-drawer>
    <el-drawer v-model="dialogCompareVisible2" :title="node_name2" direction="rtl" :before-close="handleClose" :size="'auto'"
      modal-class="modal_transparent">
      <div class="my_dialog" v-if="dialogCompareVisible2">
        <table class="detail_table" border="1">
          <tr class="detail_title">
            <td class="detail_attr">车型</td>
            <template v-for="(item, ind) in model_list2" :key="ind">
              <td class="detail_title_item" colspan="1">
                {{ item.short_name }}
              </td>
            </template>
          </tr>

          <tr class="detail_tr_item">
            <td class="detail_attr">测评项</td>
            <template v-for="(item, ind) in detail_list2" :key="ind">
              <td class="detail_val">
                <div class="td_score">
                  {{ item.node_name }}
                </div>
              </td>
            </template>
          </tr>

          <tr class="detail_tr_item">
            <td class="detail_attr">
              <div>维度评分</div>
            </td>
            <template v-for="(item, ind) in detail_list2" :key="ind">
              <td class="detail_val">
                <div class="td_score table_text">
                  <p>惊喜：{{ item.surprise_score || 0 }}分</p>
                  <p>实用：{{ item.practical_score || 0 }}分</p>
                  <p>独创：{{ item.originality_score || 0 }}分</p>
                </div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">
              <div>综合得分</div>
            </td>
            <template v-for="(item, ind) in detail_list2" :key="ind">
              <td class="detail_val">
                <div class="attr_box">
                  <div class="attr_node_score">
                    <span class="attr_node_score_num" style="color:#f00">{{ item.synthetical_score }}分</span>
                  </div>
                </div>
              </td>
            </template>
          </tr>

          <tr class="detail_tr_item">
            <td class="detail_attr">图片素材</td>
            <template v-for="(item, ind) in detail_list2" :key="ind">
              <td class="detail_val">
                <template v-if="item.item['3'] && item.item['3'].ext_info.length > 0">
                  <div class="detail_val_pic">
                    <div class="detail_pic_left" @click.stop="
                      previewImg(item.item['3'] && item.item['3'].ext_info, 'img')
                      ">
                      <div class="detail_pic_left_img">
                        <img :src="item.item['3'].ext_info[0].attach_value || ''" alt="图片加载失败" />
                        <span class="more_pic">{{
                          item.item['3'] && item.item['3'].ext_info.length
                          }}</span>
                      </div>
                      <div class="look_pic">点击查看图片</div>
                    </div>
                    <div v-if="item.item['3'] && item.item['3'].item_value_val" class="detail_pic_right detail_val_text"
                      v-html="item.item['3'] && item.item['3'].item_value_val"></div>
                  </div>
                  <!-- <div class="download_btn"
                    @click="downloadFn(item.item['3'] && item.item['3'].ext_info, model_list2[ind].short_name, node_name2)">
                  </div> -->
                </template>
                <div class="no_img" v-else>当前测试子节点本次未涉及图片素材</div>

              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">视频素材</td>
            <template v-for="(item, ind) in detail_list2" :key="ind">
              <td class="detail_val">
                <template v-if="item.item['4'] && item.item['4'].ext_info.length > 0">
                  <div class="detail_val_video">
                    <div class="detail_video_left" @click.stop="
                      previewImg(item.item['4'] && item.item['4'].ext_info, 'video')
                      ">
                      <div class="detail_pic_left_video">
                        <video controlsList="nodownload" :src="item.item['4'].ext_info[0].attach_value"
                          :poster="item.item['4'].ext_info[0].attach_value + '?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'"
                          preload="none"></video>
                        <span class="more_pic">{{
                          item.item['4'] && item.item['4'].ext_info.length
                          }}</span>
                      </div>
                      <div class="look_pic">点击查看视频</div>
                    </div>
                    <div class="detail_pic_right detail_val_text" v-if="item.item['4'] && item.item['4'].item_value_val"
                      v-html="item.item['4'] && item.item['4'].item_value_val"></div>
                  </div>
                  <!-- <div class="download_btn" 
                    @click="downloadFn(item.item['4'] && item.item['4'].ext_info, model_list2[ind].short_name, node_name2)">
                  </div> -->
                </template>
                <div class="no_img" v-else>当前测试子节点本次未涉及视频素材</div>

              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">主观评价</td>
            <template v-for="(item, ind) in detail_list2" :key="ind">
              <td class="detail_val">
                <div class="td_evaluation table_text">
                  <template v-for="(p_item, p_ind) in item.item" :key="p_ind">
                    <p v-if="
                      p_item.item_value_val &&
                      p_item.item_value_type != 4 &&
                      p_item.item_value_type != 5
                    " v-html="p_item.item_value_val"></p>
                  </template>
                </div>
              </td>
            </template>
          </tr>


        </table>
      </div>
    </el-drawer>
    <div class="my_swiper_dialog" v-if="swiperVisible">
        <div class="my_swiper_dialog_content">
            <div class="my_swiper_dialog_close" @click="closeSwiperDialog"></div>
            <swiper :list="preview_list" :type="preview_type" />
        </div>
    </div>
</template>

<script>
import {
    ElTabs, ElTabPane, ElDatePicker, ElConfigProvider, ElImage,
    ElTable,
    ElTableColumn,
    ElCheckbox,
    ElCheckboxGroup,
    ElMessage,

    ElDrawer,
} from 'element-plus';

import Swiper from "@/components/swiper/Swiper.vue";
import {
    getOtaIndexData, getOtaFuncData, getOtaFunc2Data, getOtaFuncDetail, getOtaBrandData, getOtaBrandDetail, getOtaYearData, getOtaKeywordDetail,
    getSearchResoultV2, getTestDetailV2, getSearchResoultCxV2,getInnovateDetailV2

} from '@/api';
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import { ref } from 'vue';
import VChart from 'vue-echarts';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { TitleComponent, TooltipComponent, LegendComponent, GraphicComponent, GridComponent } from 'echarts/components';
import { PieChart, BarChart } from 'echarts/charts';

use([CanvasRenderer, TitleComponent, TooltipComponent, LegendComponent, PieChart, GraphicComponent, GridComponent, BarChart]);

export default {
    components: {
        ElTabs,
        ElTabPane,
        ElDatePicker,
        ElConfigProvider,
        VChart,
        ElImage,
        ElTable,
        ElTableColumn,
        ElCheckbox,
        ElCheckboxGroup,
        Swiper,
        ElDrawer
    },
    name: "otaIndex",
    setup() {
        const activeName = 'index';
        const indexData = {};
        const searchType = ref(0);
        const tempStartMonth = ref('');
        const tempEndMonth = ref('');
        const startMonth = ref('');
        const endMonth = ref('');
        const functionOption = ref({});
        const function1Option = ref({});
        const function2Option = ref({});
        const addTypeOption = ref({});
        const brandOption = ref({});
        const versionOption = ref({});
        const currentFunction0 = ref({});
        const currentFunction1 = ref({});
        const currentFunction2 = ref({});
        const functionDetail = ref([]);
        const keywordDetail = ref([]);
        const functionStage = ref(0);
        const brandStage = ref(0);
        const currentBrand = ref({});
        const brandFuncOption = ref({});
        const yearFunctionOption = ref({});
        const yearBrandOption = ref({});
        const brandVersionOption = ref({});
        const hasFetchedYearData = ref(false);
        const minDate = ref('');
        const maxDate = ref('');
        const dialogVisible = ref(false);
        const loading = ref(false);
        const loading2 = ref(false);
        const node_list = ref(null);
        const node_list2 = ref(null);
        const dialogCompareVisible = ref(false);
        const node_name = ref('');
        const model_list = ref([]);
        const detail_list = ref([]);
        const node_name2 = ref('');
        const model_list2 = ref([]);
        const detail_list2 = ref([]);
        const dialogCompareVisible2 = ref(false);
        const other1Option = ref({});
        const other2Option = ref({});
        const other3Option = ref({});


        const disabledStartDate = (date) => {
            if (!minDate.value || !maxDate.value) {
                return true; // 禁用所有日期，直到 minDate 和 maxDate 被设置
            }
            
            const currentYearMonth = date.getFullYear() * 100 + (date.getMonth() + 1);
            const minYearMonth = parseInt(minDate.value.replace('-', ''));
            const maxYearMonth = parseInt(maxDate.value.replace('-', ''));

            // 先检查日期范围
            if (currentYearMonth < minYearMonth || currentYearMonth > maxYearMonth) {
                return true;
            }

            // 再检查与结束日期的关系
            if (tempEndMonth.value) {
                const selectedEndDate = new Date(tempEndMonth.value);
                return date > selectedEndDate;
            }

            return false;
        };

        const disabledEndDate = (date) => {
            if (!minDate.value || !maxDate.value) {
                return true; // 禁用所有日期，直到 minDate 和 maxDate 被设置
            }
            
            const currentYearMonth = date.getFullYear() * 100 + (date.getMonth() + 1);
            const minYearMonth = parseInt(minDate.value.replace('-', ''));
            const maxYearMonth = parseInt(maxDate.value.replace('-', ''));

            // 先检查日期范围
            if (currentYearMonth < minYearMonth || currentYearMonth > maxYearMonth) {
                return true;
            }

            // 再检查与开始日期的关系
            if (tempStartMonth.value) {
                const selectedStartDate = new Date(tempStartMonth.value);
                return date < selectedStartDate;
            }

            return false;
        };




        const getIndexData = () => {
            getOtaIndexData({ start_month: startMonth.value, end_month: endMonth.value }).then(res => {
                if (startMonth.value == '' && endMonth.value == '') {
                    startMonth.value = endMonth.value = tempStartMonth.value = tempEndMonth.value = res.data.date_scope.max;
                }

                if (minDate.value == '' || maxDate.value == '') {
                    minDate.value = res.data.date_scope.min;
                    maxDate.value = res.data.date_scope.max;
                }

                let functionData = []
                res.data.function_count.forEach(element => {
                    functionData.push({
                        name: element.function_0.name,
                        value: element.total,
                        function_0_id: element.function_0_id,
                    })
                });
                functionOption.value = getPieOption(functionData);

                let addTypeData = []
                res.data.add_type_count.forEach(element => {
                    addTypeData.push({
                        name: element.add_type,
                        value: element.total,
                    })
                });
                addTypeOption.value = getPieOption(addTypeData);


                let brandData = []
                res.data.brand_count.forEach(element => {
                    let itemData = {
                        name: element.brand.name.replace('汽车', ''),
                        id: element.brand_id,
                        items: []
                    }
                    element.function.forEach(func => {
                        itemData.items.push({
                            name: func.function_0.name,
                            value: func.total
                        })
                    })
                    brandData.push(itemData);
                });
                brandOption.value = getBarOption(brandData, 1, 21, 10)

                let versionData = []
                res.data.brand_version_count.forEach(element => {
                    versionData.push({
                        name: element.brand.name,
                        value: element.distinct_version_count,
                        function_2_id: element.brand_id,
                    })
                });

                versionOption.value = getGradientBarOption(versionData);
            })
        }

        const getYearData = () => {

            getOtaYearData().then(res => {
                let functionData = []
                res.data.function_data.forEach(element => {
                    let itemData = {
                        name: element.month,
                        id: element.month,
                        items: []
                    };
                    element.data.forEach(item => {
                        console.log(item, element)
                        itemData.items.push({
                            name: item.function_0.name,
                            value: item.total
                        })
                    })
                    functionData.push(itemData);
                });
                yearFunctionOption.value = getBarOption(functionData, 1, 30);

                let brandData = []
                res.data.brand_data.forEach(element => {
                    let itemData = {
                        name: element.month,
                        id: element.month,
                        items: []
                    };
                    element.data.forEach(item => {
                        itemData.items.push({
                            //name: item.brand.name,
                            name: item.name,
                            value: item.total
                        })
                    })
                    brandData.push(itemData);
                });
                yearBrandOption.value = getBarOption(brandData, 2, 30);



                let brandVersionData = []
                res.data.brand_version_data.forEach(element => {
                    console.log(element)
                    brandVersionData.push({
                        name: element.brand.name,
                        value: element.distinct_version_count,
                        function_2_id: element.brand_id,
                    })
                });

                brandVersionOption.value = getGradientBarOption(brandVersionData);
                other1Option.value = getGradientBarOption(res.data.other1);
                other2Option.value = getGradientBarOption(res.data.other2);
                other3Option.value = getGradientBarOption(res.data.other3);

            })
        }

        const getBarOption = (data, style, width, left) => {
            let legendData = []
            let xAxisData = []
            let series = []
            const color = ['#0485E2', '#11B6EF', '#8ED0FE', '#626262', '#8F8F8F', '#BFBFBF', '#DCDCDC']

            data.forEach(items => {
                items.items.forEach(item => {
                    if (!legendData.includes(item.name)) {
                        legendData.push(item.name)
                        series.push(
                            {
                                name: item.name,
                                type: 'bar',
                                stack: '总量',
                                data: [],
                                itemStyle: {
                                    color: color[series.length]
                                },
                                label: {
                                    show: true,
                                    formatter: (params) => params.value !== 0 ? params.value : ''
                                },
                                barWidth: width
                            },
                        )
                    }
                })
                xAxisData.push({
                    value: items.name,
                    id: items.id
                })
            })

            data.forEach(items => {
                series.forEach((serie, serieIndex) => {
                    const results = items.items.filter(obj => obj.name === serie.name);
                    if (results.length == 0) {
                        series[serieIndex].data.push(0)
                    } else {
                        series[serieIndex].data.push(results[0].value)
                    }
                })
            })
            if (style == 1) {
                const totalData = xAxisData.map((_, dataIndex) => {
                    return series.reduce((sum, serie) => sum + (serie.data[dataIndex] || 0), 0);
                });

                const totalSeries = {
                    name: '总数',
                    type: 'bar',
                    stack: '总量',
                    label: {
                        show: true,
                        position: 'top',
                        formatter: (params) => {
                            const total = totalData[params.dataIndex];
                            return total !== 0 ? total : '';
                        }
                    },
                    itemStyle: {
                        color: 'transparent'
                    },
                    data: data.map(() => 0)
                };
                series.push(totalSeries);
            }

            if (style == 2) {
                series.forEach(serie => {
                    serie.label.position = 'right';
                });
            }

            return {
                grid: {
                    left: left + '%',
                    containLabel: true
                },
                legend: {
                    data: legendData,
                    orient: 'horizontal',
                    left: 'center',
                    top: 'bottom'
                },
                xAxis: {
                    type: 'category',
                    data: xAxisData,
                    axisLabel: {
                        fontSize: 10,
                        color: '#404248'
                    },
                    triggerEvent: true
                },
                yAxis: {
                    type: 'value',
                },
                series: series,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function (params) {
                        let tooltipContent = `<strong>${params[0].axisValue}</strong><br/>`;
                        params.forEach((item, index) => {
                            if (style != 1 || index != params.length - 1) {
                                tooltipContent += `${item.marker} <strong>${item.seriesName}</strong>: ${item.value}<br/>`;
                            }
                        });
                        return tooltipContent;
                    },
                    backgroundColor: '#f2f2f2',
                    borderColor: '#ccc',
                    borderWidth: 1,
                    textStyle: {
                        color: '#333',
                        fontSize: 12
                    }
                },
            }
        }

        const getFuncData = () => {
            getOtaFuncData({ start_month: startMonth.value, end_month: endMonth.value, function_0_id: currentFunction0.value.id }).then(res => {
                let functionData = []
                res.data.function_count.forEach(element => {
                    functionData.push({
                        name: element.function_1.name,
                        value: element.total,
                        function_1_id: element.function_1_id,
                    })
                });
                function1Option.value = getPieOption(functionData);

                onChartFinished();
            })
        }

        const getFunc2Data = () => {
            getOtaFunc2Data({ start_month: startMonth.value, end_month: endMonth.value, function_1_id: currentFunction1.value.id }).then(res => {
                let functionData = []
                res.data.function_count.forEach(element => {
                    functionData.push({
                        name: element.function_2.name,
                        value: element.total,
                        function_2_id: element.function_2_id,
                    })
                });

                function2Option.value = getGradientBarOption(functionData);
                onChartFinished();
            })
        }

        const getFuncDetail = () => {
            getOtaFuncDetail({ start_month: startMonth.value, end_month: endMonth.value, function_2_id: currentFunction2.value.id }).then(res => {
                functionDetail.value = res.data.list;
            })
        }

        const getBrandDetail = () => {
            getOtaBrandDetail({ start_month: startMonth.value, end_month: endMonth.value, function_2_id: currentFunction2.value.id, brand_id: currentBrand.value.id }).then(res => {
                functionDetail.value = res.data.list;
            })
        }

        const getBrandFunc = () => {
            getOtaBrandData({ start_month: startMonth.value, end_month: endMonth.value, brand_id: currentBrand.value.id }).then(res => {
                let brandData = []
                res.data.brand_count.forEach(element => {
                    brandData.push({
                        name: element.function_2.name,
                        value: element.total,
                        function_2_id: element.function_2_id,
                    })
                });

                brandFuncOption.value = getGradientBarOption(brandData);
                onChartFinished();
            })
        }

        const getGradientBarOption = (data) => {
            return {
                grid: {
                    left: '0%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: data.map(item => ({
                        id: item.function_2_id,
                        value: item.name,
                        textStyle: {
                            color: '#404248'
                        }
                    })),
                    axisLabel: {
                        fontSize: 10,
                        color: '#404248'
                    },
                    triggerEvent: true
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: data.map(item => item.value),
                    type: 'bar',
                    barWidth: 30,
                    itemStyle: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: '#65BFFF'
                            }, {
                                offset: 1, color: '#ACF9ED'
                            }],
                            global: false
                        }
                    },
                    label: {
                        show: true,
                        position: 'top',
                        formatter: '{c}'
                    }
                }]
            };
        }

        const getPieOption = (data) => {
            return {
                graphic: {
                    type: 'image',
                    id: 'background',
                    left: 'center',
                    top: '7%',
                    z: -10,
                    bounding: 'raw',
                    style: {
                        image: '//img.cy-cdn.com/ceping/pie_bg.jpg',
                        width: 200,
                        height: 200,
                        opacity: 0.5
                    }
                },
                legend: {
                    orient: 'horizontal',
                    left: 'center',
                    top: 'bottom',
                    data: data.map((item) => ({
                        name: item.name,
                        textStyle: {
                            color: '#404248'
                        }
                    })),
                },
                series: [
                    {
                        type: 'pie',
                        radius: '60%',
                        center: ['50%', '40%'],
                        color: ['#0485E2', '#11B6EF', '#8ED0FE', '#6884d8', '#0f36ac'],
                        label: {
                            position: 'inside',
                            formatter: '{d}%'
                        },
                        labelLine: {
                            show: false
                        },
                        itemStyle: {
                            borderColor: '#FFFFFF',
                            borderWidth: 1
                        },
                        data: data,
                        emphasis: {
                            itemStyle: {
                                borderColor: '#FFFFFF',
                                borderWidth: 1
                            }
                        }
                    }
                ]
            };
        }

        const onFunctionChartClick = (params) => {
            if (!params.name) return;
            currentFunction0.value = {
                data: [],
                name: params.name,
                id: params.data.function_0_id
            }
            const clickedIndex = params.dataIndex;
            functionOption.value = {
                ...functionOption.value,
                legend: {
                    ...functionOption.value.legend,
                    data: functionOption.value.legend.data.map((item, index) => ({
                        ...item,
                        textStyle: {
                            color: index === clickedIndex ? '#1FBCBF' : '#404248',
                            fontWeight: index === clickedIndex ? '900' : 'normal'
                        }
                    }))
                }
            };

            //重置柱状图颜色
            const xAxisData = brandOption.value.xAxis.data.map((label) => ({
                value: typeof label === 'object' ? label.value : label,
                id: typeof label === 'object' ? label.id : undefined,
                textStyle: {
                    color: '#404248'
                }
            }));
            brandOption.value = {
                ...brandOption.value,
                xAxis: {
                    ...brandOption.value.xAxis,
                    data: xAxisData
                }
            };

            functionStage.value = 1;
            brandStage.value = 0;
            getFuncData();
        };

        const onFunction1ChartClick = (params) => {
            if (!params.name) return;
            currentFunction1.value = {
                data: [],
                name: params.name,
                id: params.data.function_1_id
            }
            const clickedIndex = params.dataIndex;
            function1Option.value = {
                ...function1Option.value,
                legend: {
                    ...function1Option.value.legend,
                    data: function1Option.value.legend.data.map((item, index) => ({
                        ...item,
                        textStyle: {
                            color: index === clickedIndex ? '#1FBCBF' : '#404248',
                            fontWeight: index === clickedIndex ? '900' : 'normal'
                        }
                    }))
                }
            };

            functionStage.value = 2;
            getFunc2Data();
        };

        const onFunction2ChartClick = (params) => {
            let clickedName = '';
            let clickedId = '';
            if (params.componentType === 'xAxis') {
                const clickedIndex = params.dataIndex;
                const xAxisData = function2Option.value.xAxis.data.map((label, index) => ({
                    value: label.value,
                    id: typeof label === 'object' ? label.id : undefined,
                    textStyle: {
                        color: index === clickedIndex ? '#1FBCBF' : '#404248',
                        fontWeight: index === clickedIndex ? '900' : 'normal'
                    }
                }));

                function2Option.value = {
                    ...function2Option.value,
                    xAxis: {
                        ...function2Option.value.xAxis,
                        data: xAxisData
                    }
                };
                clickedName = xAxisData[clickedIndex].value;
                clickedId = xAxisData[clickedIndex].id;
            } else if (params.componentType === 'series') {
                const clickedIndex = params.dataIndex;

                const xAxisData = function2Option.value.xAxis.data.map((label, index) => ({
                    value: typeof label === 'object' ? label.value : label,
                    id: typeof label === 'object' ? label.id : undefined,
                    textStyle: {
                        color: index === clickedIndex ? '#1FBCBF' : '#404248',
                        fontWeight: index === clickedIndex ? '900' : 'normal'
                    }
                }));

                function2Option.value = {
                    ...function2Option.value,
                    xAxis: {
                        ...function2Option.value.xAxis,
                        data: xAxisData
                    }
                };

                clickedName = params.name;
                clickedId = xAxisData[clickedIndex].id;
            }
            currentFunction2.value = {
                name: clickedName,
                id: clickedId
            }

            functionStage.value = 3;
            getFuncDetail();
        }

        const onBrandFuncChartClick = (params) => {
            let clickedName = '';
            let clickedId = '';
            if (params.componentType === 'xAxis') {
                const clickedIndex = params.dataIndex;
                const xAxisData = brandFuncOption.value.xAxis.data.map((label, index) => ({
                    value: label.value,
                    id: typeof label === 'object' ? label.id : undefined,
                    textStyle: {
                        color: index === clickedIndex ? '#1FBCBF' : '#404248',
                        fontWeight: index === clickedIndex ? '900' : 'normal'
                    }
                }));

                brandFuncOption.value = {
                    ...brandFuncOption.value,
                    xAxis: {
                        ...brandFuncOption.value.xAxis,
                        data: xAxisData
                    }
                };
                clickedName = xAxisData[clickedIndex].value;
                clickedId = xAxisData[clickedIndex].id;
            } else if (params.componentType === 'series') {
                const clickedIndex = params.dataIndex;

                const xAxisData = brandFuncOption.value.xAxis.data.map((label, index) => ({
                    value: typeof label === 'object' ? label.value : label,
                    id: typeof label === 'object' ? label.id : undefined,
                    textStyle: {
                        color: index === clickedIndex ? '#1FBCBF' : '#404248',
                        fontWeight: index === clickedIndex ? '900' : 'normal'
                    }
                }));

                brandFuncOption.value = {
                    ...brandFuncOption.value,
                    xAxis: {
                        ...brandFuncOption.value.xAxis,
                        data: xAxisData
                    }
                };

                clickedName = params.name;
                clickedId = xAxisData[clickedIndex].id;
            }
            currentFunction2.value = {
                name: clickedName,
                id: clickedId
            }

            brandStage.value = 2;
            getBrandDetail();
        }

        const onBrandChartClick = (params) => {
            // if (!params.name) return;
            let clickedName = '';
            let clickedId = '';
            //点击名字
            if (params.componentType === 'xAxis') {
                const clickedIndex = params.dataIndex;

                const xAxisData = brandOption.value.xAxis.data.map((label, index) => ({
                    value: typeof label === 'object' ? label.value : label,
                    id: typeof label === 'object' ? label.id : undefined,
                    textStyle: {
                        color: index === clickedIndex ? '#1FBCBF' : '#404248',
                        fontWeight: index === clickedIndex ? '900' : 'normal'
                    }
                }));

                brandOption.value = {
                    ...brandOption.value,
                    xAxis: {
                        ...brandOption.value.xAxis,
                        data: xAxisData
                    }
                };

                clickedName = xAxisData[clickedIndex].value;
                clickedId = xAxisData[clickedIndex].id;
            } else if (params.componentType === 'series') {
                //点击柱状图
                const clickedIndex = params.dataIndex;

                const xAxisData = brandOption.value.xAxis.data.map((label, index) => ({
                    value: typeof label === 'object' ? label.value : label,
                    id: typeof label === 'object' ? label.id : undefined,
                    textStyle: {
                        color: index === clickedIndex ? '#1FBCBF' : '#404248',
                        fontWeight: index === clickedIndex ? '900' : 'normal'
                    }
                }));

                brandOption.value = {
                    ...brandOption.value,
                    xAxis: {
                        ...brandOption.value.xAxis,
                        data: xAxisData
                    }
                };

                clickedName = params.name;
                clickedId = xAxisData[clickedIndex].id;

            }

            //重置饼图颜色
            functionOption.value = {
                ...functionOption.value,
                legend: {
                    ...functionOption.value.legend,
                    data: functionOption.value.legend.data.map((item) => ({
                        ...item,
                        textStyle: {
                            color: '#404248'
                        }
                    }))
                }
            };

            currentBrand.value = {
                name: clickedName,
                id: clickedId
            }
            functionStage.value = 0;
            brandStage.value = 1;
            getBrandFunc();
        };

        const search = () => {
            startMonth.value = tempStartMonth.value;
            endMonth.value = tempEndMonth.value;
            functionStage.value = 0;
            brandStage.value = 0;
            getIndexData();
        }

        const scrollToBottom = () => {
            const elMain = document.querySelector('.el-main');
            if (elMain) {
                elMain.scrollTo({
                    top: elMain.scrollHeight,
                    behavior: 'smooth'
                });
            }
        };

        const onChartFinished = () => {
            setTimeout(() => {
                scrollToBottom();
            }, 200);
        };

        const handleClick = (element) => {
            if (element.props.label === '年度统计' && !hasFetchedYearData.value) {
                getYearData();
                hasFetchedYearData.value = true;
            }
        }

        getIndexData();


        const searchLike = (item, type) => {
            searchType.value = type
            dialogVisible.value = true
            if (type == 1) {
                getOtaKeywordDetail({ tags: item.tags, id: item.id }).then(res => {
                    console.log(res.data.list)
                    keywordDetail.value = res.data.list
                })
            }
            if (type == 2) {
                getSearchResoultV2({
                    keyword: item.item,
                }).then((res) => {
                    console.log('res1', res.data);
                    node_list.value = res.data.map(nodeItem => {
                        return {
                            ...nodeItem,
                            checked_list: []
                        }
                    }) || [];
                    console.log('node_list', node_list);
                    loading.value = false;
                });
            }
            if (type == 3) {
                getSearchResoultCxV2({
                    //keyword: item.tags,
                    keyword: item.tags
                }).then((res) => {
                    console.log('res2', res.data);
                    node_list2.value = res.data.map(item => {
                        return {
                            ...item,
                            checked_list: []
                        }
                    }) || [];
                    loading2.value = false;
                });
            }
        }

        const closeDialog = () => {
            dialogVisible.value = false;
        };

        // getYearData();


        const contrastFn = (row) => {
            let { checked_list, name, node_id } = row;
            node_name.value = name;
            model_list.value = JSON.parse(JSON.stringify(checked_list))
            if (!model_list.value.length) {
                ElMessage.warning("请选择对比车型！");
                return;
            }

            let promise_list2 = model_list.value.map((item) => {
                return new Promise((resolve, reject) => {
                    getTestDetailV2({
                        report_id: item.report_id,
                        model_id: item.model_id,
                        node_id: node_id,
                    })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
            });
            Promise.all(promise_list2).then((res_list) => {
                detail_list.value = res_list.map((res) => {
                    let item_value = {
                        has_permission: res.code == 503 ? 1 : 0
                    };
                    if (res.data && res.data.item_value) {
                        res.data.item_value.forEach((item) => {
                            item_value[item.item_value_val_type] = item;
                        });
                        item_value["9"] = res.data["node_desc"];
                    }
                    return item_value;
                });
                dialogCompareVisible.value = true;
            });

        }

        const swiperVisible = ref(false);
        const preview_list = ref([]);
        const preview_type = ref("img");
        const previewImg = (list, type) => {
            console.log(list, type)
            preview_list.value = list;
            preview_type.value = type;
            swiperVisible.value = true;
        };
        const closeSwiperDialog = () => {
            document.querySelectorAll("video").forEach((item) => {
                item.pause();
            });
            swiperVisible.value = false;
        };
        const objectSpanMethod = ({ row, column, rowIndex, columnIndex }) => {
            if (columnIndex == 2) {
                if (rowIndex == 0) {
                    return {
                        rowspan: node_list2.value.length,
                        colspan: 1,
                        row: row,
                        column: column
                    }
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    }
                }
            }
        }

        const contrastFn2 = () => {
            // let { name } = row;
            console.log('node_list2.value', node_list2.value)
            //node_name2.value = name;
            node_name2.value = '创新项对比'
            // 合并所有的checked_list子数组
            const allCheckedLists = node_list2.value.reduce((acc, item) => {
                return acc.concat(item.checked_list);
            }, []);
            model_list2.value = JSON.parse(JSON.stringify(allCheckedLists));
            if (!model_list2.value.length) {
                ElMessage.warning("请选择对比车型！");
                return;
            }
            let promise_list = allCheckedLists.map(item => {
                return new Promise((resolve, reject) => {
                    getInnovateDetailV2({
                        report_id: item.report_id,
                        model_id: item.model_id,
                        node_ids: item.node_id
                    }).then((res) => {
                        resolve(res);
                    }).catch((err) => {
                        reject(err);
                    });
                })
            })
            Promise.all(promise_list).then(res_list => {
                detail_list2.value = res_list.map(res_item => {
                    let res_item_data = res_item.data[0];
                    let item_item_val = {};
                    res_item_data.item.forEach(item_item => {
                        item_item_val[item_item.item_value_type] = item_item;
                    })
                    res_item_data.item = item_item_val;
                    return res_item_data;
                })
                dialogCompareVisible2.value = true;
            })

            console.log(model_list2.value, detail_list2.value)

        }

        return {
            detail_list2,
            dialogCompareVisible2,
            model_list2,
            node_name2,
            objectSpanMethod,
            previewImg,
            swiperVisible,
            closeSwiperDialog,
            preview_list,
            preview_type,
            dialogCompareVisible,
            contrastFn,
            searchType,
            handleClick,
            indexData,
            activeName,
            zhCn,
            startMonth,
            endMonth,
            tempStartMonth,
            tempEndMonth,
            functionOption,
            addTypeOption,
            brandOption,
            versionOption,
            onBrandChartClick,
            onFunctionChartClick,
            search,
            currentFunction0,
            currentFunction1,
            currentFunction2,
            function1Option,
            function2Option,
            onFunction1ChartClick,
            onFunction2ChartClick,
            functionDetail,
            functionStage,
            brandStage,
            currentBrand,
            brandFuncOption,
            onBrandFuncChartClick,
            onChartFinished,
            yearFunctionOption,
            yearBrandOption,
            brandVersionOption,
            disabledStartDate,
            disabledEndDate,
            searchLike,
            dialogVisible,
            keywordDetail,
            closeDialog,
            loading,
            loading2,
            node_list,
            node_name,
            model_list,
            detail_list,
            node_list2,
            contrastFn2,
            other1Option,
            other2Option,
            other3Option
        }
    }
}
</script>

<style lang="less" scoped>
.detail-list {
    max-width: 1080px;
}

.detail-item {
    // margin-bottom: 25px;
}

.detail-content {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #404248;
    font-style: normal;
    margin-top: 12px;
}

.detail-img {
    margin-top: 16px;
    height: 140px;
    margin-right: 25px;
}

.detail-item-main {
    display: flex;
}

.detail-item-title {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #000000;
    line-height: 19px;
    font-style: normal;
    display: flex;
    align-items: center;
}

.child-1 {
    margin-top: 54px;
}

.c-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 17px;
    color: #404248;
    line-height: 24px;
    font-style: normal;
}

.c-title-line {
    display: flex;
    margin-top: 10px;
}

.line-1 {
    width: 20px;
    height: 2px;
    background: #1FBCBF;
}

.line-2 {
    width: 59px;
    height: 2px;
    background: #DCDCDC;
}

.white_bg {
    min-height: calc(100vh - 128px);
    padding: 48px 56px 48px 59px;
}


:deep(.el-tabs__item) {
    width: 185px;
    font-weight: 400;
    font-family: MicrosoftYaHei;
    font-size: 17px;
    color: #0E0A31;
    line-height: 22px;
    font-style: normal;
    text-align: center;
}

:deep(.el-dialog) {
    max-height: 70vh;
    overflow: scroll;
}

.dialog-custom {
    max-height: 70vh !important;
    overflow: scroll !important;
}

:deep(.el-tabs__item.is-active) {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 17px;
    color: #0E0A31;
    line-height: 22px;
    font-style: normal;
}

:deep(.el-tabs__active-bar) {
    width: 165px !important;
    background-color: #1FBCBF;
}

.p-title {
    margin: 20px 0;
    display: flex;
    font-family: MicrosoftYaHei;
    font-size: 17px;
    color: #404248;
    line-height: 22px;
    text-align: right;
    font-style: normal;
}

.p-block {
    width: 6px;
    height: 23px;
    background: #1FBCBF;
    margin-right: 23px;
}

.date-bg {
    width: 100%;
    height: 58px;
    background: #EFF4FA;
    border-radius: 2px;
    display: flex;
    align-items: center;
}

.date-text {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #191919;
    line-height: 19px;
    text-align: left;
    font-style: normal;
    margin-left: 30px;
    margin-right: 30px;
}

.date-input {
    width: 145px;
    height: 34px;
    background: #FFFFFF;
    line-height: 34px;

    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #ABABAB;
    text-align: center;
    font-style: normal;
    cursor: pointer;
}

.date-line {
    width: 19px;
    height: 1px;
    border: 1px solid #C1D3EE;
    margin-left: 30px;
}

.date-btn {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
    font-style: normal;

    width: 109px;
    height: 34px;
    background: #1FBCBF;
    border-radius: 4px;
    line-height: 34px;
    margin-left: 43px;
    cursor: pointer;
}

:deep(.el-date-editor .el-input__prefix, .el-date-editor .el-input__suffix) {
    display: none;
}

:deep(.el-date-editor .el-input__inner) {
    text-align: center;
    width: 145px;
}

:deep(.el-date-editor.el-input, .el-date-editor.el-input__inner) {
    width: 145px;
}

.index-count {
    margin-top: 25px;
    display: flex;
}

.count-box {
    width: 395px;
    height: 398px;
    background: #FFFFFF;
    border-radius: 7px;
    border: 1px solid #E9E9E9;
    margin-right: 27px;
}

.count-box:hover {
    box-shadow: 3px 5px 16px 0px rgba(152, 152, 152, 0.5);
}

.count-checked {
    box-shadow: 3px 5px 16px 0px rgba(152, 152, 152, 0.5);
}

.count-title {
    margin-top: 27px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.count-text {
    font-weight: bold;
    font-size: 17px;
    color: #404248;
    line-height: 22px;
    font-style: normal;
    padding: 0 20px;
}

.count-line {
    width: 50px;
    height: 1px;
    border: 1px solid #D9D9D9;
}

.count-title-2 {
    text-align: center;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #404248;
    line-height: 19px;
    font-style: normal;
    margin-top: 8px;
}

.charts {
    display: flex;
    justify-content: center;
}

.mt-10 {
    margin-top: 30px;
}

.mt-50 {
    margin-top: 50px;
}

.sp-line {
    height: 1px;
    width: 100%;
    background: #d0d0d0;
    margin: 20px 0;
    opacity: 0.5;
}

.detail-item-model {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #8b909d;
    font-style: normal;
    margin-top: 10px;
    width: 600px;
    border: 1px solid #ccc;
    padding: 5px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
}

.like-btn {
    margin-left: 10px;
    color: blue;
    cursor: pointer;
}

.custom-dialog-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.custom-dialog {
    background-color: white;
    width: 90%;
    height: 70vh;
    overflow-y: auto;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    position: relative;
}

.custom-dialog-header {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #ccc;
}

.close-button {
    background: none;
    border: none;
    font-size: 24px;
    font-weight: bold;
    color: #333;
    cursor: pointer;
    transition: color 0.3s;
}

.close-button:hover {
    color: #ff5c5c;
}

.custom-dialog-content {
    padding: 20px;
}

.table_container {
    width: 1130px;
    margin: 20px auto;
}

.node_name {
    padding: 0 10px;
    font-size: 16px;
    color: #555;
    font-weight: 900;
}

.path_names {
    padding: 0 10px;
    font-size: 12px;
    white-space: pre-wrap;
}

.model_list {
    flex-wrap: wrap;

    .model_name {
        flex-grow: 0;
        width: 200px;
        margin: 0;
    }
}

.contrast_btn {
    color: #709ae8;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: pointer;
}

:deep(.modal_transparent) {
    background: transparent;
}

.detail_table .detail_tr_item .detail_val>div.detail_val_text {
    padding: 16px 17px;
    white-space: pre-line;
}

.no_img {
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #777c89;
}

.detail_val_pic {
    display: flex;
    align-items: center;

    .detail_pic_left {
        width: 73px;
        height: 80px;
        cursor: pointer;

        .detail_pic_left_img {
            width: 73px;
            height: 60px;
            position: relative;

            img {
                height: 100%;
                width: 100%;
                object-fit: cover;
            }

            .more_pic {
                width: 20px;
                height: 25px;
                background: rgba(0, 0, 0, 0.5);
                position: absolute;
                bottom: 0;
                right: 0;
                text-align: center;
                list-style: 25px;
                font-size: 13px;
                font-weight: bold;
                color: #ffffff;
            }
        }
    }

    .detail_pic_right {
        font-size: 12px;
        font-weight: bold;
        color: #777c89;
        line-height: 16px;
    }
}

.detail_val_video {
    display: flex;
    align-items: center;

    .detail_video_left {
        width: 92px;
        height: 84px;
        cursor: pointer;

        .detail_pic_left_video {
            width: 92px;
            height: 64px;
            position: relative;

            video {
                height: 100%;
                width: 100%;
                object-fit: cover;
            }

            .more_pic {
                width: 20px;
                height: 25px;
                background: rgba(0, 0, 0, 0.5);
                position: absolute;
                bottom: 0;
                right: 0;
                text-align: center;
                list-style: 25px;
                font-size: 13px;
                font-weight: bold;
                color: #ffffff;
            }
        }

        .look_pic {
            width: 100%;
            height: 16px;
            font-size: 12px;
            color: #5287ea;
            line-height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

.look_pic {
    width: 100%;
    height: 16px;
    font-size: 12px;
    color: #5287ea;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.my_swiper_dialog {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 5000;

    .my_swiper_dialog_content {
        width: auto;
        height: auto;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

        .my_swiper_dialog_close {
            width: 50px;
            height: 50px;
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/a467vc54678bvt67bv.png) no-repeat center center;
            background-size: 50px 50px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 40px;
            position: absolute;
            top: 40px;
            right: 40px;
            z-index: 2;
            cursor: pointer;
        }
    }
}

.my_dialog {
    width: auto;
    height: auto;
    background: #fff;
    border-radius: 15px;
    padding: 10px;
    max-width: 90vw;
    height: calc(100vh - 75px);
    overflow-x: auto;
    overflow-y: auto;
    z-index: 99;
}
</style>